import React, { Children } from 'react'
import './styles.scss'
import '../../styles/index.scss'

export default ({ children, colsSizes = [], colDefaultSize = 6, extraClasses = [], className = '' }) => {
  return (
    <div className={`row ${className}`}>
      {Children.map(children, (child, i) => {
        return (
          <div className={`col-md-${colsSizes[i] || colDefaultSize} form-group check-error ${extraClasses[i] || ''}`}>
            {child}
          </div>
        )
      })}
    </div>
  )
}
